import { render } from "./AlertBar.vue?vue&type=template&id=455e0535&scoped=true"
import script from "./AlertBar.vue?vue&type=script&lang=js"
export * from "./AlertBar.vue?vue&type=script&lang=js"

import "./AlertBar.vue?vue&type=style&index=0&id=455e0535&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455e0535"]])

export default __exports__